import { LOCALES } from '~/constants/main';
import { TBooleanInNumber } from '~/types/main';

export const kioskCast = (data: any) => ({
  id: String(data.id),
  language: String(data.language) as LOCALES,
  password: String(data.password),
  branchId: String(data.branch_id),
  branchName: String(data.branch_name),
  terminalId: String(data.terminal_id),
  ip: String(data.ip),
  port: String(data.port),
  status: Number(data.status) as TBooleanInNumber,
  isDelete: Number(data.is_delete) as TBooleanInNumber,
  kiosk_terminal_multiplier: Number(data.kiosk_terminal_multiplier),
});

export type TKiosk = ReturnType<typeof kioskCast>;
